<template>
    <div class="backBox">
        <transition name="fade">
            <div v-if="isShowNotice&&isPair" class="pre-notice" @click="noticeConfirm=true">
                <img src="../../assets/equipment-pair/notice.png" class="notice">
                {{$t("equipmentPair.noPairedClickedDetails")}}
                <img src="../../assets/equipment-pair/double-right.png" class="double-right">
            </div>
        </transition>
        <div v-show="showTop" class="mask-gray-m" @click="showTop=false"></div>
            <div class="equ-detail">
                <div class="pad">
                    <div class="equ-one-detail">
                        <div class="one">
                            <img :src="parentDevice.imgPath==''?localPhoto:parentDevice.imgPath" class="img-detail">
                            <div class="detail-info">
                                <div>
                                    {{parentDevice.remark}} &nbsp;&nbsp;
                                    <img src="../../assets/equipment-pair/edit.png" @click="editEquName(parentDevice.remark)">
                                </div>
                                <div>
                                    SN：{{parentDevice.deviceId}}
                                </div>
                                <div>
                                    {{$t("equipmentPair.deviceVersion")}}：{{parentDevice.hardVersion}}
                                </div>
                                <div>
                                    {{$t("equipmentPair.softwareVersion")}}：{{parentDevice.softVersion}}
                                </div>
                            </div>
                        </div>
                        <div class="two">
                            <div class="number">
                                <span class="blue">{{parentDevice.childCount}}</span>
                                <span class="gray"><span style="margin: 0 2px">/</span>{{parentDevice.maxChild}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div style="padding: 10px 15px;margin-top: 10px">
                <div class="part-title">
                    <span style="font-size: 18px;font-weight: 600">{{$t('equipmentPair.clientDevicesList')}}</span>
                </div>
                <div class="part-title">
                    <div class="left-filter">
                        <div :class="dFilterType==='gmtModified'?'time-filter active':'time-filter'" @click="filterChange('gmtModified')">
                            {{$t('equipmentPair.deviceDate')}}
                            <div v-if="dFilterType==='gmtModified'">
                                <img v-if="dTimeSort" src="../../assets/equipment-pair/asc.png">
                                <img v-else src="../../assets/equipment-pair/desc.png">
                            </div>
                            <div v-else><img src="../../assets/equipment-pair/dis-filter.png"></div>
                        </div>
                        <div :class="dFilterType==='remark'?'name-filter active':'name-filter'" @click="filterChange('remark')">
                            {{$t('equipmentPair.deviceName')}}
                            <div v-if="dFilterType==='remark'">
                                <img v-if="dNameSort" src="../../assets/equipment-pair/asc.png">
                                <img v-else src="../../assets/equipment-pair/desc.png">
                            </div>
                            <div v-else><img src="../../assets/equipment-pair/dis-filter.png"></div>
                        </div>
                    </div>
                    <div class="detail-pair">
                        <div v-if="isPair" class="pair-btn end" @click="endPair">{{$t('equipmentPair.stopPair')}}</div>
                        <div v-else class="pair-btn begin" @click="beginPair">{{$t('equipmentPair.startPair')}}</div>
                        <div v-if="!isPair">
                            <div v-if="dCheck" @click="cancelCheck">{{$t('equipmentPair.cancel')}}</div>
                            <div v-else @click="editEqu">{{$t('equipmentPair.edit')}}</div>
                        </div>
                    </div>
                </div>
            </div>
        <div class="equ-list">
            <van-checkbox-group v-model="checkDResult">
                <div v-for="item in childDevice" :key="item.deviceId" class="equ-one-bottom">
                    <div class="mask white-m-half" v-show="item.status===6"></div>
                    <div class="mask white-m" v-show="dMask&&item.status!=6"></div>
                    <van-checkbox :name="item" v-show="dMask&&item.status!=6" class="check" style="right: 20px;"></van-checkbox>
                    <div :class="item.status===3?'equ-one red-back':'equ-one'" style="padding: 15px">
                        <div class="one">
                            <img :src="item.imgPath==''?localPhoto:item.imgPath" class="img-list">
                            <div class="one-info">
                                <div class="two1">
                                    {{item.remark}}
                                    &nbsp;&nbsp;<img src="../../assets/equipment-pair/edit.png" @click="editTerminalName(item.remark,item.deviceId)">
                                </div>
                                <div v-if="item.status!=6" class="two2">SN：{{item.deviceId}}</div>
                            </div>
                        </div>
                        <div class="two">
                            <div v-if="item.status===1" class="pair disPair"><img src="../../assets/equipment-pair/dis-pair.png">&nbsp;{{$t('equipmentPair.statusNoPaired')}}</div>
                            <div v-if="item.status===2" class="pair pairing">&nbsp;{{$t('equipmentPair.statusWaitingToPair')}}</div>
                            <div v-if="item.status===3" class="pair pairing"><img src="../../assets/equipment-pair/pair-process.gif">&nbsp;{{$t('equipmentPair.statusPairing')}}</div>
                            <div v-if="item.status===4" class="pair off-pair"><img src="../../assets/equipment-pair/off-pair.png">&nbsp;{{$t('equipmentPair.statusPairFailed')}}</div>
                            <div v-if="item.status===5" class="pair paired"><img src="../../assets/equipment-pair/pair-success.gif">&nbsp;{{$t('equipmentPair.statusPairSuccessed')}}</div>
                            <div v-if="item.status===6" class="pair pairing"><img src="../../assets/equipment-pair/bind.png">&nbsp;{{$t('equipmentPair.statusBinded')}}</div>
                        </div>
                        <div v-if="item.status===6" class="bind-text">
                            {{$t('equipmentPair.deviceBindedNoAllowedToOperate')}}
                        </div>
                    </div>
                    <transition name="fade">
                        <div v-if="item.status===3" class="pairing-text">
                            {{$t('equipmentPair.devicePairingTip')}}
                        </div>
                    </transition>
                </div>
            </van-checkbox-group>
        </div>

        <div v-if="dCheck" class="fixBottom bottom-btn">
            <van-button v-if="checkDResult.length>0" color="#286EFF" round class="terminal" @click="delEqu">{{$t('equipmentPair.delete')}}</van-button>
            <van-button v-else color="#DADADA" round class="terminal">{{$t('equipmentPair.delete')}}</van-button>
            <van-button type="info" round plain class="terminal" @click="cancelCheck">{{$t('equipmentPair.cancel')}}</van-button>
        </div>

        <!-- 添加按钮-->
        <div v-if="isAdd&&!isPair" class="add-equ" @click="showAddPopup">
            <img src="../../assets/equipment-pair/add.png">
            <div>{{$t('equipmentPair.addClientDevice')}}</div>
        </div>

        <van-popup v-model="addPopup" position="bottom" @close="isAdd=true">
            <div class="popup-title">
                {{$t('equipmentPair.addClientDevice')}}
                <span v-if="childDevice.length==parentDevice.maxChild">{{$t('equipmentPair.deviceNumberOver')}}</span>
            </div>
            <div class="popup-content">
                <div v-if="childDevice.length==parentDevice.maxChild" class="mask white-m"></div>
                <div class="part" @click="snInput">
                    <img src="../../assets/equipment-pair/gray-input.png"> &nbsp;{{$t('equipmentPair.enterSN')}}
                </div>
                <div class="part" @click="chooseEqu">
                    <img src="../../assets/equipment-pair/gray-equ.png"> &nbsp;{{$t('equipmentPair.deviceOwned')}}
                </div>
                <div class="part" @click="scanEqu">
                    <img src="../../assets/equipment-pair/gray-scan.png"> &nbsp;{{$t('equipmentPair.scaleQRCode')}}
                </div>
            </div>
        </van-popup>


        <!--提示-->
        <van-dialog
                v-model="noticeConfirm"
                :title="$t('default.prompt')"
                class="self-dialog-orange"
                @confirm="noticeConfirm=false"
                :confirm-button-text="$t('equipmentPair.confirm')"
                :cancel-button-text="$t('equipmentPair.cancel')"
        >
            <template slot="default">
                <div class="confirm-content">
                    <div style="padding: 20px 0 5px 10px;font-size: 2.2vh;">
                        <ul class="text-ul">
                            <li><span class="dialog-text">{{$t('equipmentPair.pairingPromptText1')}}</span></li>
                            <li><span class="dialog-text">{{$t('equipmentPair.pairingPromptText2')}}</span></li>
                        </ul>
                    </div>
                </div>
            </template>
        </van-dialog>

        <!--添加终端设备输入SN码-->
        <div class="dialog-mask" v-show="snChildConfirm">
            <div class="dialog" ref="childSN">
                <div class="content">
                    <div class="title">{{$t('equipmentPair.enterClientInfo')}}</div>
                    <img src="../../assets/equipment-pair/QRCode.png" class="qrCode">
                    <van-field
                            v-model="deviceId"
                            class="move-input"
                            :placeholder="$t('equipmentPair.tipEnterSN')"
                            @focus="snInputVal"
                            @blur="inputLeave"
                    />
                    <van-field
                            v-model="serialCode"
                            class="move-input"
                            :placeholder="$t('equipmentPair.tipEnter4PlaceSecurityCode')"
                            @focus="codeInputVal"
                            @blur="inputLeave"
                    />
                </div>
                <div class="footer">
                    <div class="cancel-btn" @click="closeChildSnInput">{{$t('equipmentPair.cancel')}}</div>
                    <div class="sure-btn" @click="addChildEqu">{{$t('equipmentPair.confirm')}}</div>
                </div>
            </div>
        </div>

        <!--编辑名称-->
        <van-dialog
                v-model="nameConfirm"
                :title="$t('equipmentPair.deviceName')"
                show-cancel-button
                cancel-button-color="#999999"
                class="self-dialog"
                :before-close="nameBeforeClose"
                :confirm-button-text="$t('equipmentPair.confirm')"
                :cancel-button-text="$t('equipmentPair.cancel')"
        >
            <template slot="default">
                <div class="confirm-content">
                    <van-field
                            v-model="remark"
                            class="move-input"
                            :placeholder="$t('equipmentPair.tipEnterName')"
                            @input="netNameFilter"
                    />
                </div>
            </template>
        </van-dialog>

        <!--编辑终端设备名称-->
        <van-dialog
                v-model="terminalNameConfirm"
                :title="$t('equipmentPair.clientNameTitle')"
                show-cancel-button
                cancel-button-color="#999999"
                class="self-dialog"
                :before-close="terminalNameBeforeClose"
                :confirm-button-text="$t('equipmentPair.confirm')"
                :cancel-button-text="$t('equipmentPair.cancel')"
        >
            <template slot="default">
                <div class="confirm-content">
                    <van-field
                            v-model="terminalRemark"
                            class="move-input"
                            :placeholder="$t('equipmentPair.tipEnterClientName')"
                            @input="terNameFilter"
                    />
                </div>
            </template>
        </van-dialog>

        <!--选择终端设备-->
        <van-dialog
                v-model="equCheckConfirm"
                show-cancel-button
                cancel-button-color="#999999"
                class="self-dialog"
                :before-close="chooseChildEqu"
                :confirm-button-text="$t('equipmentPair.confirm')"
                :cancel-button-text="$t('equipmentPair.cancel')"
        >
            <template slot="default">
                <div class="equ-choose">
                    <div class="search-box">
                        <form action="/">
                            <van-search v-model="searchEqu" shape="round" class="equ-search" :placeholder="$t('equipmentPair.searchTitle')" @search="searchChildEqu"/>
                        </form>
                        <div class="filter" @click="terminalEquSheet=true">
                            <span>{{terminalEquText}}</span> <img src="../../assets/equipment-pair/filter.png">
                        </div>
                    </div>
                    <div class="terminal-list">
                        <van-checkbox-group v-model="checkEqu">
                            <van-list
                                    v-model="loading"
                                    :finished="finished"
                                    :finished-text="$t('default.noMore')"
                                    @load="onLoadEqu"
                            >
                                <div v-for="(item,index) in terminalEqu" :key="index" class="terminal-part">
                                    <van-checkbox
                                            :name="item"
                                            class="check-equ"
                                            icon-size="18px"
                                    >
                                    </van-checkbox>
                                    <div>{{$t('equipmentPair.deviceName')}}：{{item.remark}}</div>
                                    <p>{{$t('equipmentPair.sn')}}：{{item.deviceId}}</p>
                                </div>
                            </van-list>
                        </van-checkbox-group>
                    </div>
                </div>
            </template>
        </van-dialog>

        <!-- 主设备删除提示-->
        <van-dialog
                v-model="delConfirm"
                :title="$t('equipmentPair.deleteGatewayControllerPromptTitle')"
                show-cancel-button
                cancel-button-color="#999999"
                class="self-dialog"
                @confirm="sureDelEqu"
                :confirm-button-text="$t('equipmentPair.confirm')"
                :cancel-button-text="$t('equipmentPair.cancel')"
        >
            <template slot="default">
                <div class="confirm-content">
                    <div class="small-red">{{$t('equipmentPair.deleteGatewayControllerPromptTip')}}</div>
                </div>
            </template>
        </van-dialog>

        <!-- 右上角弹窗-->
        <div class="right-top" v-show="showTop">
            <img src="../../assets/equipment-pair/top.png" class="top-img">
            <div v-if="!isPair" class="right-part" @click="delSelfEqu">
                <img src="../../assets/equipment-pair/del.png">&nbsp;&nbsp;{{$t('equipmentPair.delete')}}
            </div>

            <div class="right-part" @click="equWifi">
                <img src="../../assets/equipment-pair/wifi.png">&nbsp;&nbsp;{{$t('titles.deviceWifi')}}
            </div>
        </div>


        <van-action-sheet
                round
                v-model="terminalEquSheet"
                :actions="terminalEquList"
                @select="terminalEquSelect"
        />

    </div>
</template>

<script>
import Signal from "@/components/Signal";
import { Button , Dialog , Popup , Search ,Checkbox, CheckboxGroup, ActionSheet ,Toast ,Field ,List } from 'vant';
import { terminalEqu } from "@/util/equipment-pair";
import { showNavigationRightMoreButton ,showRightTop ,scanQRCode ,getAppVersion ,goTo ,inputCompress ,inputCover} from "@/util/jsbridge";
import api from "@/api/equipment-pair";
import compareVersion from "@/util/formatVersion";
import filterEmoji from "@/util/filterEmoji";

export default {
    name: "EquipmentDetails",
    components:{
        [Signal.name]:Signal,
        [Button.name]:Button,
        [Popup.name]:Popup,
        [Dialog.Component.name]: Dialog.Component,
        [Search.name]:Search,
        [Checkbox.name]:Checkbox,
        [CheckboxGroup.name]:CheckboxGroup,
        [ActionSheet.name]:ActionSheet,
        [Field.name]:Field,
        [List.name]:List,
    },
    data(){
        return{
            isAdd:true,
            timeOutEvent:0,
            addPopup:false,
            equCheckConfirm:false,
            searchEqu:"",
            checkEqu:[],
            terminalEquSheet:false,
            terminalEquList:[],
            terminalEquText:"",
            delConfirm:false,
            parentDevice:{},
            childDevice:[],
            localPhoto:require("../../assets/equipment-pair/equ-bigger.png"),
            snChildConfirm:false,
            deviceId:"",
            serialCode:"",
            parentId:this.$route.query.id,
            page:0,
            pageSize:5,
            loading:false,
            finished:false,
            type:"",
            terminalEqu:[],
            nameConfirm:false,
            remark:"",
            showTop:false,
            version:"",
            terminalNameConfirm:false,
            terminalRemark:"",
            terminalDeviceId:"",
            noticeConfirm:false,
            dFilterType:"gmtModified",
            dTimeSort:true,
            dNameSort:false,
            dCheck:false,
            checkDResult:[],
            dMask:false,
            isPair:null,
            timer:null,
            isUserClick:true,
            isShowNotice:false,
        }
    },
    created(){
        getAppVersion(this.showAppVersion);
        this.getNetEquDetail();
    },
    mounted() {
        window.getScanningQRCode = this.getScanningQRCode;
        window.navigationRightMoreButtonClicked=this.navigationRightMoreButtonClicked;
    },
    beforeDestroy(){
        clearInterval(this.timer);
        this.timer = null;
    },
    methods:{
        showAppVersion(version){
            this.version=version;
            const u = navigator.userAgent;
            const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            let manageTitle = this.$t('equipmentPair.manage')
            if (isiOS) {
                if(compareVersion(version,"3.2.2")){  //3.2.2新版可以用js方法弹右上角窗
                    showNavigationRightMoreButton(true,manageTitle);
                }else {   //3.2.2老版只能用路径跳转的方式弹
                    showRightTop("[{url:'', text:'"+this.$t("default.newVersionNotice")+"'}]", this.$t("default.newVersionNotice"));
                }
            } else {
                if(compareVersion(version,"3.1.7")){  //3.1.7新版可以用js方法弹右上角窗
                    showNavigationRightMoreButton(true,manageTitle);
                }else {   //3.1.7老版本只能用路径跳转的方式弹
                    showRightTop("[{url:'', text:'"+this.$t("default.newVersionNotice")+"'}]", this.$t("default.newVersionNotice"));
                }
            }
        },
        navigationRightMoreButtonClicked(){
            this.showTop=!this.showTop;
        },
        delSelfEqu(){
            this.delConfirm=true;
            this.showTop=false;
        },
        equWifi(){
            this.showTop=false;
            goTo("https://app.robooot.com/wifi/WifiConfigActivity",'','','');
        },


        snInputVal(){
            this.$refs.childSN.style.bottom=16+'%';
        },
        codeInputVal(){
            this.$refs.childSN.style.bottom=15+'%';
        },
        inputLeave(){
            window.scrollTo(0,0);
            this.$refs.childSN.style.bottom=30+'%';
        },

        snInput(){
            this.snChildConfirm=true;
            this.addPopup=false;
            this.$nextTick(()=>{
                this.isAdd=false;
            });
            inputCompress();
        },
        closeChildSnInput(){
            this.snChildConfirm=false;
            this.isAdd=true;
            inputCover();
        },
        showAddPopup(){
            this.addPopup=true;
            this.isAdd=false;
        },
        chooseEqu(){
            this.equCheckConfirm=true;
            this.addPopup=false;
            this.terminalEquList=terminalEqu();
            this.terminalEquText=this.terminalEquList[0].name;
            this.checkEqu=[];
            this.searchEqu="";
            this.page=1;
            this.terminalEqu=[];
            this.loadChildEquList();
        },
        onLoadEqu(){
            this.page+=1;
            this.loadChildEquList();
        },
        searchChildEqu(){
            this.page=1;
            this.terminalEqu=[];
            this.loadChildEquList();
        },
        terminalEquSelect(val){
            this.checkEqu=[];
            this.terminalEquText=val.name;
            this.type=val.en;
            this.terminalEquSheet=false;
            this.page=1;
            this.terminalEqu=[];
            this.loadChildEquList();
        },

        //获取全部信息
        getNetEquDetail(){
            let params={
                parentId:this.parentId,
                orderBy:this.dFilterType,
            };
            if(this.dFilterType==='gmtModified'){
                params['desc']=this.dTimeSort
            }else {
                params['desc']=this.dNameSort
            }
            api.getMainDetail(params).then(res=>{
                if(res.result==0){
                    this.parentDevice=res.data.parentDevice;
                    this.childDevice=res.data.childDevice;
                    if(!res.data.parentDevice.online||!res.data.linkDoing){
                        //开始配对后如果没有联网或者终端设备都没有在配对中时,显示黄色提示
                        this.isShowNotice=true
                    }else {
                        this.isShowNotice=false
                    }
                    //showBtn:true是正在配对，false是配对结束
                    this.isPair=res.data.showBtn;
                    if(res.data.showBtn&&this.isUserClick){
                        this.isUserClick=false;
                        this.timer = setInterval(this.getNetEquDetail, 3000);
                    }

                    if(!res.data.showBtn){
                        if(this.timer||this.timer!=null){
                            clearInterval(this.timer);
                            this.timer = null;
                        }
                    }
                }else {
                    Toast(res.message);
                }
            })
        },

        //获取未添加的子设备列表
        loadChildEquList(){
            this.loading=true;
            api.getChildEquList({
                status:7,
                page:this.page,
                pageSize:this.pageSize,
                type:this.type,
                deviceId:this.searchEqu
            }).then(res=>{
                if(res.result==0){
                    let self=this;
                    res.data.result.forEach(function (n) {
                        self.terminalEqu.push(n)
                    });
                    self.loading=false;
                    self.finished = false;
                    self.page=res.data.page;
                    if(self.terminalEqu.length==res.data.total){
                        self.finished=true;
                    }
                }else {
                    Toast(res.message);
                }
            })
        },

        netNameFilter(value){
            this.remark=filterEmoji(value)
        },

        terNameFilter(value){
            this.terminalRemark=filterEmoji(value);
        },

        //编辑名称
        editEquName(name){
            this.nameConfirm=true;
            this.remark=name;
        },
        nameBeforeClose(action, done){
            if (action === 'confirm') {
                if(this.remark==""){
                    Toast({ message:this.$t('equipmentPair.tipEnterName') , duration:1000});
                    done(false);
                }else {
                    done();
                    api.addOrEditEqu({
                        deviceId:this.parentDevice.deviceId,
                        hasAdd:false,
                        name:this.remark
                    }).then(res=>{
                        if(res.result==0){
                            Toast(this.$t('equipmentPair.successTip'));
                            this.getNetEquDetail();
                        }else {
                            Toast(res.message);
                        }
                    })
                }
            }else {
                done();
                this.nameConfirm=false;
            }
        },

        //编辑终端设备名称
        editTerminalName(name,deviceId){
            this.terminalRemark=name;
            this.terminalDeviceId=deviceId;
            this.terminalNameConfirm=true;
        },
        terminalNameBeforeClose(action, done){
            if (action === 'confirm') {
                if(this.terminalRemark==""){
                    Toast({ message:this.$t('equipmentPair.tipEnterClientName') , duration:1000});
                    done(false);
                }else {
                    done();
                    api.addOneChild({
                        deviceId:this.terminalDeviceId,
                        parentId:"",
                        hasAdd:false,
                        name:this.terminalRemark
                    }).then(res=>{
                        if(res.result==0){
                            Toast(this.$t('equipmentPair.successTip'));
                            this.getNetEquDetail();
                        }else {
                            Toast(res.message);
                        }
                    })
                }
            }else {
                done();
                this.terminalNameConfirm=false;
            }
        },

        //批量添加子设备
        chooseChildEqu(action, done){
            if (action === 'confirm') {
                let childIds=[];
                this.checkEqu.forEach(function (n) {
                    childIds.push(n.deviceId);
                });
                if(childIds.length==0){
                    done(false);
                    Toast({ message:this.$t('equipmentPair.addClientTip') , duration:1000});
                }else {
                    done();
                    api.addCheckChildEqu({
                        childIds:childIds,
                        parentId:this.parentId
                    }).then(res=>{
                        if(res.result==0){
                            this.getNetEquDetail();
                            Toast(this.$t('equipmentPair.successTip'));
                        }else {
                            Toast(res.message);
                        }
                    })
                }
            }else {
                done();
                this.equCheckConfirm=false;
            }
        },

        //输入SN添加子设备
        addChildEqu(){
            api.addOneChild({
                deviceId:this.deviceId,
                serialCode:this.serialCode,
                parentId:this.parentId,
                hasAdd:true,
                name:this.$t('equipmentPair.deviceDefaultName')
            }).then(res=>{
                this.closeChildSnInput();
                if(res.result==0){
                    Toast(this.$t('equipmentPair.successTip'));
                    this.getNetEquDetail();
                }else {
                    Toast(res.message);
                }
            })
        },

        //删除子设备
        delEqu(){
            Dialog.confirm({
                title: this.$t('equipmentPair.deleteClientPromptTitle')
            }).then(() => {
                let deviceIdStr=[];
                this.checkDResult.forEach(function (n) {
                    deviceIdStr.push(n.deviceId)
                });
                api.delChildEqu({
                    deviceIdStr:deviceIdStr
                }).then(res=>{
                    if(res.result==0){
                        Toast(this.$t('equipmentPair.successTip'));
                        this.cancelCheck();
                        this.getNetEquDetail();
                    }else {
                        Toast(res.message);
                    }
                })
            }).catch(() => {
            });
        },

        //删除主设备
        sureDelEqu(){
            let deviceIdStr=[];
            deviceIdStr.push(this.parentId);
            api.delMainEqu({
                deviceIdStr:deviceIdStr,
                isBind:false
            }).then(res=>{
                if(res.result==0){
                    Toast(this.$t('equipmentPair.successTip'));
                    this.$router.replace({name:"Home"});
                }else {
                    Toast(res.message);
                }
            })
        },

        //扫码添加子设备
        scanEqu(){
            this.addPopup=false;
            scanQRCode(this.$t('equipmentPair.scaleQRCodeTitle'));
        },
        getScanningQRCode(url){
            let index = url.lastIndexOf("/");
            let str = url.substring(0,index);   //最后一个斜杠前面的值

            let deviceId = url.substring(index + 1,url.length);   //最后一个斜杠后面的值 :deviceId

            let lastIndex = str.lastIndexOf("/");
            let serialCode=str.substring(lastIndex + 1,str.length);  //:seriCode

            api.addOneChild({
                deviceId:deviceId,
                serialCode:serialCode,
                parentId:this.parentId,
                hasAdd:true,
                name:this.$t('equipmentPair.deviceDefaultName')
            }).then(res=>{
                if(res.result==0){
                    Toast(this.$t('equipmentPair.successTip'));
                    this.getNetEquDetail();
                }else {
                    Toast(res.message);
                }
            })
        },

        //开始配对
        beginPair(){
            this.isUserClick=false;
            api.beginPairEqu({
                parentId:this.parentId
            }).then(res=>{
                if(res.result==0){
                    this.getNetEquDetail();
                    this.isPair=true;
                    this.timer = setInterval(this.getNetEquDetail, 3000);
                }else {
                    Toast(res.message);
                }
            })
        },
        //结束配对
        endPair(){
            //发送结束配对请求,成功后可清除定时器并将isPair=false
            this.isPair=false;
            clearInterval(this.timer);
            this.timer = null;
            api.endPairEqu({
                parentId:this.parentId
            }).then(res=>{
                if(res.result===0){
                    this.getNetEquDetail();
                }else {
                    Toast(res.message);
                }
            })
        },

        filterChange(type){
            this.dFilterType=type;
            if(type==='gmtModified'){
                this.dTimeSort=!this.dTimeSort;
            }else {
                this.dNameSort=!this.dNameSort;
            }
            this.getNetEquDetail();
        },

        editEqu(){
            this.dCheck=true;
            this.dMask=true;
            this.isAdd=false;
        },
        cancelCheck(){
            this.dCheck=false;
            this.dMask=false;
            this.isAdd=true;
            this.checkDResult=[];
        },
    }
}
</script>

<style scoped lang="less">
@import "../../../static/less/common";
@import "../../../static/less/equ-pair";
.equ-detail{
    border-bottom: 1px solid #F0F0F0;
}
.equ-one-bottom{
    position: relative;
    margin-bottom: 1vh;
}
.equ-one-detail{
    display: flex;
    flex-direction: row;
    position: relative;
    .one{
        width: 85%;
        flex-direction: row;
        .flex-center-Y;
        img{
            width: 35%;
        }
        .detail-info{
            margin-left:10px;
            :nth-child(1){
                display: flex;
                align-items: center;
                font-size: 2.5vh;
                img{
                    width: 2vh;
                }
            }
            :nth-child(n+2){
                font-size: 2vh;
                margin-top: 1vh;
                color: #999999;
            }
        }
    }
    .two{
        width: 15%;
        .equ-signal{
            right: 20px;
            top: 20px;
            position: absolute;
        }
        .number{
            position: absolute;
            bottom: 0;
            right: 0;
            .gray{
                color: #999999;
                font-size: 2.2vh;
            }
            .blue{
                font-size: 4.5vh;
                color: #5AECCE;
            }
            .red{
                font-size: 4vh;
                color: #D62F2F;
            }
        }
    }
}
.add-equ{
    position: fixed;
    bottom: 40px;
    right: 15px;
    z-index: 1;
    color: #286EFF;
    text-align: center;
    font-size: 12px;
    img{
        width: 60px;
    }
}

.popup-title{
    border-bottom: 1px solid #F0F0F0;
    line-height: 44px;
    padding-left: 20px;
    font-size:15px;
    font-weight: bold;
    span{
        font-size: 10px;
        color: #D62F2F;
        margin-left: 5px;
    }
}
.popup-content{
    position: relative;
    font-size: 14px;
    img{
        width: 18px;
        height: 18px;
        margin-left: 40%;
        transform: translateX(-40%);
    }
    .part{
        .flex-center-Y;
        padding: 20px 0;
    }
    .part:active{
        background: #F0F0F0;
    }
}

.equ-choose{
    height: 50vh;
    padding: 5px 10px 10px 10px;
    .terminal-list{
        padding-top: 10px;
        height: 41vh;
        overflow: auto;
        .terminal-part{
            padding-left: 35px;
            font-size: 2vh;
            position: relative;
            margin-bottom: 3vh;
            p{
                font-size: 1.8vh;
                color: #999999;
            }
            .check-equ{
                position: absolute;
                left:0;
                top: 5px;
            }
        }
    }
}

.right-top{
    position: fixed;
    top: 10px;
    right: 5px;
    background: #ffffff;
    z-index: 100;
    width: 120px;
    border-radius: 5px;
    padding: 3px 0;
    color: #333333;
    .top-img{
        height: 10px;
        position: fixed;
        top: 0;
        right: 20px;
    }
    .right-part{
        height: 44px;
        width: 100%;
        padding-left: 20px;
        img{
            width: 18px;
        }
        .flex-center-Y;
    }
    .right-part:active{
        color: #999999;
    }
}
.pre-notice{
    height: 20px;
    .flex-center-Y;
    justify-content: center;
    background: #FF9916;
    color: #ffffff;
    font-size: 12px;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 2;
    .notice{
        width: 12px;
        height: 12px;
        margin-right: 3px;
    }
    .double-right{
        width: 10px;
        height: 10px;
        margin-left: 2px;
    }
}
.pairing-text{
    .flex-center-Y;
    justify-content: center;
    color: #D62F2F;
    font-size: 12px;
    background: #FCF4F4;
    padding-bottom:20px;
}
.bind-text{
    position: absolute;
    bottom: 20px;
    left: 14.5vh;
    color: #999999;
    font-size: 12px;
}
.fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
}
.fade-enter, .fade-leave-to{
    opacity: 0;
}
</style>
<style>
    .self-dialog .van-dialog__confirm, .van-dialog__confirm{
        background: #286EFF;
        color: #FFFFFF;
        border-radius: unset;
    }
    .self-dialog-orange .van-dialog__confirm, .van-dialog__confirm{
        background: #FF9916;
        color: #FFFFFF;
        border-radius: unset;
    }
    .text-ul li{
        margin-bottom: 10px;
        list-style: disc;
        color: #FF9916;
        font-size: 14px;
    }
    .dialog-text{
        color: #333333;
    }
    .check .van-checkbox__icon .van-icon{
        border: 1px solid #a2a2a2;
    }
</style>
